"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get UNIQUE_CONSTRAINT_SUPPORTED_TYPES () {
        return _nocodbsdk.UNIQUE_CONSTRAINT_SUPPORTED_TYPES;
    },
    get isUniqueConstraintSupportedType () {
        return _nocodbsdk.isUniqueConstraintSupportedType;
    },
    get normalizeValueForUniqueCheck () {
        return normalizeValueForUniqueCheck;
    },
    get validateUniqueConstraint () {
        return validateUniqueConstraint;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _catchError = require("~/helpers/catchError");
function validateUniqueConstraint(context, uidt, meta, unique, source, cdf) {
    if (!unique) return; // No validation needed if not setting unique
    // Check if source is NC-DB (meta or local)
    if (source && !source.is_meta && !source.is_local) {
        _catchError.NcError.get(context).badRequest('Unique constraint is only supported for NC-DB (not external databases)');
    }
    // Check if field type supports unique constraint
    if (!(0, _nocodbsdk.isUniqueConstraintSupportedType)(uidt, meta)) {
        const fieldTypeName = _nocodbsdk.UITypes[uidt] || uidt;
        _catchError.NcError.get(context).badRequest(`Unique constraint is not supported for field type '${fieldTypeName}'`);
    }
    // Check if default value is set (mutually exclusive with unique constraint)
    // Exception: UUID fields are allowed to have both unique constraint and auto-generation
    if (cdf !== null && cdf !== undefined && cdf !== '' && uidt !== _nocodbsdk.UITypes.UUID) {
        _catchError.NcError.get(context).badRequest('Cannot enable unique constraint because a default value is set. Please remove the default value first.');
    }
}
function normalizeValueForUniqueCheck(value, uidt) {
    if (value === null || value === undefined || value === '') {
        return null; // Treat empty values as null
    }
    // For text-based fields, trim whitespace and convert to lowercase
    if ([
        _nocodbsdk.UITypes.SingleLineText,
        _nocodbsdk.UITypes.Email,
        _nocodbsdk.UITypes.PhoneNumber,
        _nocodbsdk.UITypes.URL
    ].includes(uidt)) {
        return String(value).trim().toLowerCase();
    }
    return value;
}
